export const ADD_TO_CART = 'ADD_TO_CART'
export const CHECKOUT_REQUEST = 'CHECKOUT_REQUEST'
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS'
export const CHECKOUT_FAILURE = 'CHECKOUT_FAILURE'
export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS'

export const GET_MYPROFILE_REQUEST = 'GET_MYPROFILE_REQUEST'
export const GET_MYPROFILE_SUCCESS = 'GET_MYPROFILE_SUCCESS'
export const GET_MYPROFILE_FAILURE = 'GET_MYPROFILE_FAILURE'

export const GET_MYSITES_REQUEST = 'GET_MYSITES_REQUEST'
export const GET_MYSITES_SUCCESS = 'GET_MYSITES_SUCCESS'
export const GET_MYSITES_FAILURE = 'GET_MYSITES_FAILURE'

export const GET_SITE_REQUEST = 'GET_SITE_REQUEST'
export const GET_SITE_SUCCESS = 'GET_SITE_SUCCESS'
export const GET_SITE_FAILURE = 'GET_SITE_FAILURE'

export const GET_SITE_CAMERAS_REQUEST = 'GET_SITE_CAMERAS_REQUEST'
export const GET_SITE_CAMERAS_SUCCESS = 'GET_SITE_CAMERAS_SUCCESS'
export const GET_SITE_CAMERAS_FAILURE = 'GET_SITE_CAMERAS_FAILURE'

export const GET_SITE_CAMERA_EVENT_REQUEST = 'GET_SITE_CAMERA_EVENT_REQUEST'
export const GET_SITE_CAMERA_EVENT_SUCCESS = 'GET_SITE_CAMERA_EVENT_SUCCESS'
export const GET_SITE_CAMERA_EVENT_FAILURE = 'GET_SITE_CAMERA_EVENT_FAILURE'

export const GET_CAMERA_REQUEST = 'GET_CAMERA_REQUEST'
export const GET_CAMERA_SUCCESS = 'GET_CAMERA_SUCCESS'
export const GET_CAMERA_FAILURE = 'GET_CAMERA_FAILURE'

export const GET_CAMERA_LIVESNAPSHOT_REQUEST = 'GET_CAMERA_LIVESNAPSHOT_REQUEST'
export const GET_CAMERA_LIVESNAPSHOT_SUCCESS = 'GET_CAMERA_LIVESNAPSHOT_SUCCESS'
export const GET_CAMERA_LIVESNAPSHOT_FAILURE = 'GET_CAMERA_LIVESNAPSHOT_FAILURE'

export const GET_CAMERA_THUMBNAILVIDEOS_REQUEST = 'GET_CAMERA_THUMBNAILVIDEOS_REQUEST'
export const GET_CAMERA_THUMBNAILVIDEOS_SUCCESS = 'GET_CAMERA_THUMBNAILVIDEOS_SUCCESS'
export const GET_CAMERA_THUMBNAILVIDEOS_FAILURE = 'GET_CAMERA_THUMBNAILVIDEOS_FAILURE'

export const GET_CAMERA_THUMBNAILVIDEO_REQUEST = 'GET_CAMERA_THUMBNAILVIDEO_REQUEST'
export const GET_CAMERA_THUMBNAILVIDEO_SUCCESS = 'GET_CAMERA_THUMBNAILVIDEO_SUCCESS'
export const GET_CAMERA_THUMBNAILVIDEO_FAILURE = 'GET_CAMERA_THUMBNAILVIDEO_FAILURE'

export const GET_SITE_MEMBERS_REQUEST = 'GET_SITE_MEMBERS_REQUEST'
export const GET_SITE_MEMBERS_SUCCESS = 'GET_SITE_MEMBERS_SUCCESS'
export const GET_SITE_MEMBERS_FAILURE = 'GET_SITE_MEMBERS_FAILURE'

export const GET_MEMBER_REQUEST = 'GET_MEMBER_REQUEST'
export const GET_MEMBER_SUCCESS = 'GET_MEMBER_SUCCESS'
export const GET_MEMBER_FAILURE = 'GET_MEMBER_FAILURE'

export const GET_SITE_CONTACTS_REQUEST = 'GET_SITE_CONTACTS_REQUEST'
export const GET_SITE_CONTACTS_SUCCESS = 'GET_SITE_CONTACTS_SUCCESS'
export const GET_SITE_CONTACTS_FAILURE = 'GET_SITE_CONTACTS_FAILURE'

export const GET_CONTACT_REQUEST = 'GET_CONTACT_REQUEST'
export const GET_CONTACT_SUCCESS = 'GET_CONTACT_SUCCESS'
export const GET_CONTACT_FAILURE = 'GET_CONTACT_FAILURE'

export const ADD_CONTACT = 'ADD_CONTACT'
export const REMOVE_CONTACT = 'REMOVE_CONTACT'
export const ADD_MEMBER = 'ADD_MEMBER'
export const REMOVE_MEMBER = 'REMOVE_MEMBER'

export const SELECT_SITE = 'SELECT_SITE'
export const SELECT_DATE = 'SELECT_DATE'
export const SELECT_CAMERA = 'SELECT_CAMERA'
export const SELECT_EVENT = 'SELECT_EVENT'
export const SELECT_VIDEO = 'SELECT_VIDEO'
export const SELECT_THUMBNAILVIDEO = 'SELECT_THUMBNAILVIDEO'
export const SELECT_MEMBER = 'SELECT_MEMBER'
export const SELECT_CONTACT = 'SELECT_CONTACT'

export const OPEN_MENU = 'OPEN_MENU'
export const CLOSE_MENU = 'CLOSE_MENU'

export const ADD_LOG = 'ADD_LOG'

export const CONNECT_MQTT_REQUEST = 'CONNECT_MQTT_REQUEST'
export const CONNECT_MQTT_SUCCESS = 'CONNECT_MQTT_SUCCESS'
export const CONNECT_MQTT_FAILURE = 'CONNECT_MQTT_FAILURE'

export const MQTT_CONNECTED = 'MQTT_CONNECTED'
export const MQTT_DISCONNECTED = 'MQTT_DISCONNECTED'

export const MQTT_SITE_SUBSCRIBE = 'MQTT_SITE_SUBSCRIBE'
export const MQTT_SITE_UNSUBSCRIBE = 'MQTT_SITE_UNSUBSCRIBE'

export const INTERNET_CONNECTED = 'INTERNET_CONNECTED'
export const INTERNET_DISCONNECTED = 'INTERNET_DISCONNECTED'

export const API_RATELIMIT_LOCKED = 'API_RATELIMIT_LOCKED'
export const API_RATELIMIT_UNLOCKED = 'API_RATELIMIT_UNLOCKED'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js